import { render, staticRenderFns } from "./MovieTicketDetails.vue?vue&type=template&id=29c1453f&scoped=true"
import script from "./MovieTicketDetails.vue?vue&type=script&lang=js"
export * from "./MovieTicketDetails.vue?vue&type=script&lang=js"
import style0 from "./MovieTicketDetails.vue?vue&type=style&index=0&id=29c1453f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c1453f",
  null
  
)

export default component.exports